import styled from 'styled-components'
import { media } from '../utils/media'

export const OccupationNavBar = styled.div`
  min-height: 70px;
  background: #133E66;
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/molecules/OccupationNavBar.tsx